module.exports = __webpack_public_path__ + "img/矩形@2x(5).acb1e9c3.png";